// extracted by mini-css-extract-plugin
export default {"headerDiv":"header-card_headerDiv__XOemO"};